module.exports = __webpack_public_path__ + "img/feedback.70d046f4.svg";